export default function MySQL_COS() {
  return (
    <div>
      <h2>MySQL_COS</h2>    </div>
  );
}